module.exports = __webpack_public_path__ + "static/media/Van-Icon.4763a0c7.svg";